module.exports = __webpack_public_path__ + "img/Infografis_EN_21.77a468d4.jpg";